import React from 'react';
import './detailBoxCompany.css';
import { iconMapping } from '../../../../utils/icons';

const DetailBoxCompany = ({ title, data, id }) => {

  
  if (!data || typeof data !== 'object') {
    return null;
  }

  const handleFormatBoxLabel = (key) => {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2') 
      .replace(/_/g, ' ') 
      .replace(/^./, (str) => str.toUpperCase()); 
  };

  return (
    <div className="detail-box-company__detail-box" id={id}>
      <h3>{title}</h3>
      <ul>
        {Object.entries(data).map(([key, value]) => {
          const formattedKey = handleFormatBoxLabel(key); 
          const Icon = iconMapping[key] || iconMapping['default']; 

          return (
            <li key={key} className="detail-box-company__icon-info-container">
              <div className="detail-box-company__icon-container">
                {Icon}
              </div>
              <div className="detail-box-company__label-info-container">
                <strong>{formattedKey}</strong>: 
                <p>{value}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DetailBoxCompany;
